export const SATISFY_ROUTES = ['thanksEvaluate', 'outdateEvaluate', 'finishEvaluate', 'satisfy']
export const mobilePx = 750
export const KEX = 'kex'
export const kexApp = "kexApp"

